
export const initToursGrid = () => {
    initFilters()
    initTourFilters()
}

function initFilters() {
    document.querySelectorAll('.filter-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
            const clickedInsideFilter = e.target.closest('.filter');

            if (clickedInsideFilter) return;

            const isOpen = btn.classList.contains('is-active');

            document.querySelectorAll('.filter-btn').forEach(item => {
                item.classList.remove('is-active');
            });

            if (!isOpen) {
                btn.classList.add('is-active');
            }
        });
    });

    document.addEventListener('click', (e) => {
        if (!e.target.closest('.filter-btn')) {
            document.querySelectorAll('.filter-btn').forEach(btn => {
                btn.classList.remove('is-active');
            });
        }
    });

    document.querySelectorAll('.filter input').forEach(input => {
        input.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    });

    document.querySelector('#reset-filters')?.addEventListener('click', () => {
        document.querySelectorAll('.filter input[type="checkbox"]').forEach(input => {
            input.checked = false;
        });

        document.querySelectorAll('.filter-btn').forEach(btn => {
            btn.classList.remove('is-active');
        });
    });
}

let checkboxes, searchCountElement, noResultsElement, resetButton
export const initTourFilters = () => {
    checkboxes = document.querySelectorAll('.filter-wrapper input[type="checkbox"]');
    searchCountElement = document.getElementById('search-count'); // Element to show the count of tours
    noResultsElement = document.getElementById('no-results');
    resetButton = document.getElementById('reset-filters');

    if (!searchCountElement) {
        return
    }

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', handleCheckboxChange);
    });

    if (resetButton) {
        resetButton.addEventListener('click', function () {
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });
            handleCheckboxChange(); // Reset the filtered results

            updateGridDividers();
        });
    }

    handleCheckboxChange()

    if (window.innerWidth < 600) {
        mobileFilterToggles()
    }
}

function mobileFilterToggles() {
    const filterHeadings = document.querySelectorAll('.filters-wrapper .filter h5');

    filterHeadings.forEach(heading => {
        heading.addEventListener('click', function () {
            const parentFilter = heading.parentElement;

            parentFilter.classList.toggle('active');
        });
    });
}

function handleCheckboxChange() {
    const selectedFilters = {
        tourType: [],
        countries: [],
        difficulty: []
    };

    let selectedCount = 0;

    // Loop through all checkboxes to check their state
    checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
            selectedCount++;
            const filterName = checkbox.closest('.filter-btn').querySelector('p').innerText.trim();

            if (filterName === 'Tour type') {
                selectedFilters.tourType.push(checkbox.name);
            } else if (filterName === 'Country') {
                selectedFilters.countries.push(checkbox.name);
            } else if (filterName === 'Difficulty') {
                selectedFilters.difficulty.push(checkbox.name);
            }
        }
    });

    if (selectedCount > 0) {
        resetButton.style.display = 'inline-flex';

    } else {
        resetButton.style.display = 'none';
    }

    // Filter the tour tiles based on the selected checkboxes
    filterTours(selectedFilters);
    updateActiveFilters();
}

function filterTours(filters) {
    const tourTiles = document.querySelectorAll('.cell-wrapper');
    let visibleCount = 0;

    tourTiles.forEach(tile => {
        const dataInfo = tile.getAttribute('data-info').split(',');
        const [tourType, ...countriesAndDifficulty] = dataInfo;
        const difficulty = countriesAndDifficulty.pop(); // Last item is difficulty
        const countries = countriesAndDifficulty; // Remaining are countries

        const matchesTourType = filters.tourType.length === 0 || filters.tourType.includes(tourType);
        const matchesCountry = filters.countries.length === 0 || filters.countries.some(country => countries.includes(country));
        const matchesDifficulty = filters.difficulty.length === 0 || filters.difficulty.includes(difficulty);

        if (matchesTourType && matchesCountry && matchesDifficulty) {
            tile.style.display = 'block';
            visibleCount++;
        } else {
            tile.style.display = 'none';
        }
    });

    searchCountElement.textContent = visibleCount;

    if (visibleCount === 0) {
        noResultsElement.style.display = 'block';
    } else {
        noResultsElement.style.display = 'none';
    }

    updateGridDividers()
}

function updateGridDividers() {
    // Number of ticked options next to each filter name
    document.querySelectorAll('.filter-btn').forEach(btn => {
        const count = btn.querySelectorAll('input:checked').length
        const badge = btn.querySelector('.filter-btn__count')
        if (badge) badge.textContent = count || ''
        btn.classList.toggle('has-selection', count > 0)
    })

    const grid = document.querySelector('.tours_grid .grid');
    if (!grid || !grid.querySelector('.grid-divider')) return;
    const visibleCells = [...grid.querySelectorAll('.cell-wrapper')]
        .filter(cell => cell.style.display !== 'none');

    // Remove old JS dividers
    grid.querySelectorAll('.grid-divider.js-divider').forEach(div => {
        div.remove();
    });

    // Hide original PHP dividers
    grid.querySelectorAll('.grid-divider').forEach(div => {
        div.style.display = 'none';
    });

    // Add new dividers after every 2 visible cells
    visibleCells.forEach((cell, index) => {
        const isSecondInRow = (index + 1) % 2 === 0;
        const isNotLast = index < visibleCells.length - 1;

        if (isSecondInRow && isNotLast) {
            const divider = document.createElement('div');
            divider.classList.add('grid-divider', 'js-divider');

            cell.insertAdjacentElement('afterend', divider);
        }
    });
}

function updateActiveFilters() {
    const container = document.getElementById('active-filters');

    const activeFilters = [
        ...document.querySelectorAll('.filter input[type="checkbox"]:checked')
    ];

    container.innerHTML = '';

    activeFilters.forEach(input => {
        const tag = document.createElement('div');
        tag.classList.add('active-filter');

        tag.innerHTML = `
            <span>${input.id}</span>
            <button type="button" data-filter="${input.id}">×</button>
        `;

        container.appendChild(tag);
    });

    container.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', () => {
            const input = document.getElementById(btn.dataset.filter);

            if (input) {
                input.checked = false;

                input.dispatchEvent(new Event('change'));
            }
        });
    });
}
